import React, { Fragment } from "react";

import "./Login.css";
import { REGISTER, PROJECT_REGISTER } from "App/Routes";
import TextInput from "components/shared/Inputs/TextInput";
import PasswordInput from "../../components/shared/Inputs/PasswordInput";
import Link from "components/shared/Link/Link";
import LoginImageRow from "./LoginImageRow";
import LoginPage from "components/Login/LoginPage";

import {
  ENABLE_REGISTER_PAGES,
  ENABLE_LOGIN_HOME,
  USE_LOGIN_HOME_TEMPLATE_1,
  ENABLE_LOGIN_TOPBAR,
  ENABLE_EMAIL_LOGIN,
} from "config";

import localize from "lang/localize";
import urlServices from "services/urlServices";
import deviceServices from "services/deviceServices";

class FinalixLoginPage extends LoginPage {
  renderLoginFields() {
    if (ENABLE_EMAIL_LOGIN) {
      return (
        <Fragment>
          <TextInput
            id="emailInput"
            value={this.props.email}
            onChange={this.props.handleEmailChange}
            onKeyPress={this.handleKeyPress}
            placeholder={localize(
              "login_view_email_placeholder_text",
              this.props.language,
            )}
          />
          <PasswordInput
            id="passwordInput"
            value={this.props.password}
            onChange={this.props.handlePasswordChange}
            onKeyPress={this.handleKeyPress}
            placeholder={localize(
              "login_view_password_placeholder_text",
              this.props.language,
            )}
          />
          {this.renderResetPasswordOrResendActivation()}
          <div className="pure-g bottommargin">
            <div className="pure-u-1-1 flex justify-content-flexend">
              <button
                id="loginButton"
                className={
                  "button medium" +
                  (!!this.props.isSubmitLoading ? " disabled" : " cta")
                }
                type="submit"
                disabled={!!this.props.isSubmitLoading}
              >
                {!!this.props.isSubmitLoading
                  ? localize(
                      "nav_bar_title_generic_loading",
                      this.props.language,
                    )
                  : localize("button_login", this.props.language)}
              </button>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  renderRegisterSection() {
    if (
      !ENABLE_LOGIN_HOME ||
      (ENABLE_LOGIN_HOME && USE_LOGIN_HOME_TEMPLATE_1)
    ) {
      return (
        <Fragment>
          <br />
          <p className="textcenter">
            <strong className="subtitle">
              {localize("login_view_register_start", this.props.language) + " "}
            </strong>
            <br></br>
            <Link
              to={
                this.props.projectId
                  ? PROJECT_REGISTER.format(this.props.projectId)
                  : REGISTER
              }
              className="default"
            >
              {localize("login_view_signup_text", this.props.language)}
            </Link>
          </p>
        </Fragment>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <div className="login-register-container container verticalpadding">
        <LoginImageRow />
        <div
          className={
            "innerblock pure-g" +
            (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
          }
        >
          <div className="pure-u-1">
            <h1 className="bottommargin-40 textcenter">
              Welcome to finalix Experience!
            </h1>
          </div>
          <div className="pure-u-sm-4-24 pure-u-md-6-24" />
          <div className="pure-u-1 pure-u-sm-16-24 pure-u-md-1-2">
            <form
              className="pure-form"
              onSubmit={this.handlePreSubmit.bind(this)}
            >
              {this.renderLoginFields()}
              {/* Add hidesso=true to query string in order to hide sso login, e.g. /login?hidesso=true */}
              {urlServices.getUrlParamValueByKey("hidesso") !== "true" &&
                !deviceServices.isWebView() &&
                this.renderSSOLoginSection()}
              {ENABLE_REGISTER_PAGES && this.renderRegisterSection()}
            </form>
          </div>
          <div className="pure-u-sm-4-24 pure-u-md-6-24" />
        </div>
      </div>
    );
  }
}

export default FinalixLoginPage;
